/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A user's loyalty program status
 * @export
 * @interface UserLoyalty
 */
export interface UserLoyalty {
    /**
     * 
     * @type {string}
     * @memberof UserLoyalty
     */
    programName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserLoyalty
     */
    chainName?: string;
    /**
     * 
     * @type {number}
     * @memberof UserLoyalty
     */
    points?: number;
}

/**
 * Check if a given object implements the UserLoyalty interface.
 */
export function instanceOfUserLoyalty(value: object): value is UserLoyalty {
    return true;
}

export function UserLoyaltyFromJSON(json: any): UserLoyalty {
    return UserLoyaltyFromJSONTyped(json, false);
}

export function UserLoyaltyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLoyalty {
    if (json == null) {
        return json;
    }
    return {
        
        'programName': json['program_name'] == null ? undefined : json['program_name'],
        'chainName': json['chain_name'] == null ? undefined : json['chain_name'],
        'points': json['points'] == null ? undefined : json['points'],
    };
}

export function UserLoyaltyToJSON(json: any): UserLoyalty {
    return UserLoyaltyToJSONTyped(json, false);
}

export function UserLoyaltyToJSONTyped(value?: UserLoyalty | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'program_name': value['programName'],
        'chain_name': value['chainName'],
        'points': value['points'],
    };
}

